<template>
  <div>
    <h2>{{ $t('title.owners') }}</h2>

    <base-list
    model="owners"
    :columns="['name', 'contact_name']"
    s-model="owner"
    />
  </div>

</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'owner-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// OwnerList.vue?e47f7d30